


















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import AppTextField from '@/components/AppTextField.vue'
import AppTextarea from '@/components/AppTextarea.vue'
import { IPropertyAdditionalInput } from '@/modules/Property/interfaces/property-form'
import { states } from '@/utils/us_states'

@Component({
  components: {
    AppTextField,
    AppTextarea
  }
})
export default class PropertyFormInfo extends Vue {
  @Prop({ type: Object as () => IPropertyAdditionalInput }) value!: IPropertyAdditionalInput

  states = states

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
